import { motion } from "framer-motion";
import { PROCESS } from "@/data/home";

export const ProcessSteps = ({ dark = false }) => (
  <div className="relative" data-testid="process-steps">
    <motion.div
      className={`absolute left-0 right-0 top-[27px] hidden h-px origin-left lg:block ${dark ? "bg-lime/60" : "bg-ink/25"}`}
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      aria-hidden
    />
    <ol className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
      {PROCESS.map((p, i) => (
        <motion.li
          key={p.n}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.7, delay: 0.15 + i * 0.12 }}
          className="relative"
          data-testid={`process-step-${i + 1}`}
        >
          <span className={`relative z-10 grid h-14 w-14 place-items-center rounded-full font-display text-base font-bold ${i === 4 ? "bg-lime text-ink" : dark ? "bg-paper text-ink" : "bg-ink text-paper"}`}>{p.n}</span>
          <h3 className={`mt-6 text-xl font-semibold ${dark ? "text-white" : "text-ink"}`}>{p.t}</h3>
          <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-white/75" : "text-ink/70"}`}>{p.d}</p>
        </motion.li>
      ))}
    </ol>
  </div>
);
